import { PasswordResetState } from 'src/modules/password-reset/types/PasswordResetState';
import { RootState } from 'src/types/RootState';

export function getPasswordResetState(state: RootState): PasswordResetState {
  return state.passwordReset;
}
